<template>
  <v-app>
    <v-main>
      <FeedbackForm/>
    </v-main>
  </v-app>
</template>

<script>
import FeedbackForm from './components/FeedbackForm';

export default {
  name: 'App',

  components: {
    FeedbackForm,
  },

  data: () => ({
    //
  }),
};
</script>
